import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Carolina M.',
  location: 'CDMX',
  babyAge: 'Bebé de 4 meses',
  text: 'La primera noche que lo apliqué, mi bebé se durmió en 6 minutos. Lloré de la emoción. Llevaba semanas sin dormir más de 2 horas seguidas y ahora por fin descansamos los dos.',
  stars: 5
}, {
  name: 'Daniela R.',
  location: 'Guadalajara',
  babyAge: 'Bebé de 8 meses',
  text: 'Probé de todo: ruido blanco, mecerlo, dejarlo llorar... nada funcionaba. Con este método mi hijo se duerme tranquilo y yo dejé de tenerle miedo a las noches. Vale cada peso.',
  stars: 5
}, {
  name: 'Fernanda L.',
  location: 'Monterrey',
  babyAge: 'Bebé de 14 meses',
  text: 'Mi esposo y yo estábamos al borde. Desde que aplicamos la técnica 1-2-4, nuestra hija duerme corrido casi toda la noche. Recuperamos nuestra relación y nuestra energía.',
  stars: 5
}, {
  name: 'Sofía G.',
  location: 'Puebla',
  babyAge: 'Bebé de 6 meses',
  text: 'Soy mamá primeriza y me sentía completamente perdida. La guía de emergencia 3 AM me salvó la vida literal. Ahora cuando despierta, sé exactamente qué hacer y vuelve a dormir rapidísimo.',
  stars: 5
}];
function Stars({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-1" data-id="element-133">
      {Array.from({
      length: count
    }).map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-soft-gold text-soft-gold" data-id="element-134" />)}
    </div>;
}
export function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-white py-16 md:py-24 px-6" data-id="element-135">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.7
    }} className="max-w-5xl mx-auto" data-id="element-136">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-warm-brown mb-4 text-center" data-id="element-137">
          Lo que dicen las mamás
        </h2>
        <p className="text-warm-brown/60 text-center mb-12" data-id="element-138">
          Historias reales de mamás que recuperaron su descanso
        </p>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-139">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream rounded-xl p-6 md:p-8" data-id="element-140">
              <Stars count={testimonial.stars} data-id="element-141" />
              <p className="text-warm-brown/90 leading-relaxed mt-4 mb-6 italic" data-id="element-142">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-143">
                <div className="w-10 h-10 rounded-full bg-soft-gold/20 flex items-center justify-center" data-id="element-144">
                  <span className="text-soft-gold font-semibold text-sm" data-id="element-145">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-146">
                  <p className="font-semibold text-warm-brown text-sm" data-id="element-147">
                    {testimonial.name}
                  </p>
                  <p className="text-warm-brown/50 text-xs" data-id="element-148">
                    {testimonial.babyAge} · {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}